import { render, staticRenderFns } from "./no-inventory.vue?vue&type=template&id=24b818e7&scoped=true"
import script from "./no-inventory.vue?vue&type=script&lang=js"
export * from "./no-inventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b818e7",
  null
  
)

export default component.exports